let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6kCXg")).then(() => parcelRequire('01pGG'));